// Get currently logged-in customer's BC token in order to send it to API for verification.
// appClientId: your app's client ID
import axios from 'axios'

import store from '../store'
import { showGlobalError } from '../store/actions'

import envConfig from './envConfig'

interface CustomCheckoutWindow extends Window {
  B2B_ENV?: string
}

const customCheckoutWindow: CustomCheckoutWindow = window as CustomCheckoutWindow

const env: string = customCheckoutWindow?.B2B_ENV === 'staging' ? 'staging' : customCheckoutWindow?.B2B_ENV || 'production'

export interface BCResponse {
  status: number
  message: string
  data: object
}

export interface BCResponseError {
  message?: string
}

export interface BCTokenResponseBody {
  token?: string
}

export const getBcToken = async (): Promise<string | undefined> => {
  try {
    const response: BCResponse = await axios
      .get('/customer/current.jwt', {
        params: {
          app_client_id: envConfig[env].clientId,
        },
      })
    if (response.status !== 200) {
      store.dispatch(showGlobalError(new Error(response.message)))

      return
    }

    return (response.data as BCTokenResponseBody).token
  } catch (error) {
    store.dispatch(showGlobalError(new Error((error as BCResponseError).message)))
  }
}
